import { Fragment, useState, useEffect } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { SearchIcon } from "@heroicons/react/solid";

export default function ClubFinderDropdown(props) {
  const studios = props.items;
  const link = props.link;

  const [selected, setSelected] = useState("");
  const [query, setQuery] = useState("");

  const filteredStudios =
    query === ""
      ? studios
      : studios.filter((studio) =>
          studio.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  useEffect(() => {
    if (selected) {
      window.location.assign(selected.url);
    }
  }, [selected]);

  function returnIsMobile(){
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if(vw <= 820){
      return true;
    }else{
      return false;
    }
  }
  
 /**
  * Used until new Design
  */
  function hideOnMobile(){
    let isMobile = returnIsMobile();
    if(isMobile){
      return 'tw-invisible';
    }else{
      return '';
    }
  }
  
  function temporarilyNoTranslate(){
    let isMobile = returnIsMobile();
    if(isMobile){
      return '';
    }else{
      return 'tw--translate-y-10';
    }
  }
  function redirectIfNotFound(){
    let search = '',
        isMobile = returnIsMobile();
    if(query !== '') search = '?search='+query;
    if(isMobile){
      window.location = props.link.href+search;
    }
    if(!selected) window.location = props.link.href+search;
  }
  function enterRedirectOnMobile(e){
    let isMobile = returnIsMobile(),
        search = '';
    if(isMobile && e.keyCode === 13){
      if(query !== '') {
        search = '?search=' + query;
      }
      window.location = props.link.href+search;
    }
    console.log(e.keyCode,e.target.value);
  }
  return (
    <>
      <Combobox value={selected} onChange={!returnIsMobile() ? setSelected : (query)=> query}>
        {({ open }) => (
          <>
            <div
              className={`${
                open ? temporarilyNoTranslate() : ""
              } tw-w-full md:tw-w-8/12 tw-transition-transform tw-relative tw-z-10 tw-mt-1`}
            >
              <div className="tw-relative tw-w-full tw-cursor-default tw-overflow-hidden tw-rounded-full tw-bg-white tw-text-left tw-ring-1 tw-ring-black tw-ring-opacity-2 tw-text-lg sm:tw-text-md tw-z-10">
                <Combobox.Input
                  className="tw-w-full tw-border-none tw-py-4 tw-px-5 tw-leading-5 tw-text-black placeholder:text-black placeholder:text-sm md:tw-placeholder:text-base focus:tw-outline-none focus-visible:tw-outline-none"
                  displayValue={(studio) => studio.name}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder={props.placeholder}
                  onKeyUp={(event) => enterRedirectOnMobile(event)}
                />
                <Combobox.Button onClick={(e) => redirectIfNotFound()} className="tw-absolute tw-top-1/2 tw-right-2 tw--mt-5 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-orange tw-transition-colors hover:tw-bg-black focus:bg-black tw-text-white">
                  <SearchIcon
                    className="tw-h-5 tw-w-5 tw-text-gray-400"
                    aria-hidden="true"
                  />
                </Combobox.Button>
              </div>
              <Transition
                as={Fragment}
                enter="tw-transition tw-ease-in tw-duration-100"
                enterFrom="tw-opacity-0"
                enterTo="tw-opacity-100"
                leave="tw-transition tw-ease-in tw-duration-100"
                leaveFrom="tw-opacity-100"
                leaveTo="tw-opacity-0"
                afterLeave={() => setQuery("")}
              >
                <Combobox.Options className={hideOnMobile()+" tw-absolute tw-top-6 tw--left-8 tw--right-8 tw-max-h-64 tw-overflow-auto tw-overscroll-contain tw-rounded-md tw-bg-gray-light tw-pt-8 tw-pb-1 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-2 tw-focus:outline-none tw-text-sm md:tw-text-base tw-z-0"}>
                  <li className="tw-py-4 tw-px-4 tw-text-center">
                    <a
                      href={link.href}
                      className="tw-text-sm tw-font-bold tw-underline hover:tw-text-orange"
                    >
                      {link.label}
                    </a>
                  </li>

                  {filteredStudios.length === 0 && query !== "" ? (
                    <div className="tw-relative tw-cursor-default tw-select-none tw-py-2 tw-px-4 tw-text-gray-700">
                      …
                    </div>
                  ) : (
                    filteredStudios.map((studio) => (
                      <Combobox.Option
                        key={"studio" + studio.id}
                        className={({ active }) =>
                          `tw-relative tw-cursor-pointer tw-select-none tw-py-2 tw-px-4 ${
                            active
                              ? "tw-bg-gray-light tw-text-teal"
                              : "tw-text-black"
                          }`
                        }
                        value={studio}
                      >
                        {({ selected, active }) => (
                          <span
                            className={`tw-block tw-truncate ${
                              selected ? "tw-font-medium" : "tw-font-normal"
                            }`}
                          >
                            {studio.name}
                          </span>
                        )}
                      </Combobox.Option>
                    ))
                  )}
                </Combobox.Options>
              </Transition>
            </div>
          </>
        )}
      </Combobox>
    </>
  );
}
